import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M19 9h1a1 1 0 0 0-.293-.707L19 9zm-6-6 .707-.707A1 1 0 0 0 13 2v1zm4 17H7v2h10v-2zM6 19V5H4v14h2zM18 9v10h2V9h-2zM7 4h6V2H7v2zm12.707 4.293-6-6-1.414 1.414 6 6 1.414-1.414zM7 20a1 1 0 0 1-1-1H4a3 3 0 0 0 3 3v-2zm10 2a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1v2zM6 5a1 1 0 0 1 1-1V2a3 3 0 0 0-3 3h2z" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
